import {
  type RefObject,
  type SetStateAction,
  type Dispatch,
  createContext,
} from 'react';

export interface MicroguideContextType {
  currentStep: number;
  totalSteps: number;
  isNext: boolean;
  onClose: (currentStep: number, finished: boolean) => void;
  setHasTitle: Dispatch<SetStateAction<boolean>>;
  setHasContent: Dispatch<SetStateAction<boolean>>;
  closeButtonRef: RefObject<HTMLButtonElement | null>;
  closedOnKeydown: RefObject<boolean>;
}

const DEFAULT_CONTEXT: MicroguideContextType = {
  currentStep: 1,
  totalSteps: 1,
  isNext: true,
  onClose: () => {
    /* void */
  },
  setHasTitle: () => {
    /* void */
  },
  setHasContent: () => {
    /* void */
  },
  closeButtonRef: {
    current: null,
  },
  closedOnKeydown: {
    current: false,
  },
};

export const MicroguideContext =
  createContext<MicroguideContextType>(DEFAULT_CONTEXT);
